export default {
  translation: {
    common: {
      emailOrUsername: 'Email eller användarnamn',
      invalidUsernameOrPassword: 'Ogiltig användarnamn eller lösenord',
      logInToBoards: 'Logga in',
      noInternetConnection: 'Ingen internetanslutning',
      pageNotFound_title: 'Sidan Kunde Inte Hittas',
      password: 'Lösenord',
      serverConnectionFailed: 'Server connection failed',
      unknownError: 'Okänt fel, försök igen senare',
    },

    action: {
      logIn: 'Logga in',
    },
  },
};
